import type { PasswordAuthAdapter } from './password-auth';

export function createJwtPasswordAuth(
  loginMutation: { mutateAsync: (input: { email: string; password: string }) => Promise<{ accessToken: string; refreshToken: string }> },
  signupMutation: { mutateAsync: (input: { email: string; password: string }) => Promise<{ accessToken: string; refreshToken: string }> }
): PasswordAuthAdapter {
  return {
    async signIn(email, password) {
      try {
        const res = await loginMutation.mutateAsync({ email: email.trim(), password });
        return {
          success: true,
          accessToken: res.accessToken,
          refreshToken: res.refreshToken,
        };
      } catch (err) {
        return {
          success: false,
          error: err instanceof Error ? err.message : 'Sign in failed',
        };
      }
    },
    async signUp(email, password) {
      try {
        const res = await signupMutation.mutateAsync({ email: email.trim(), password });
        return {
          success: true,
          accessToken: res.accessToken,
          refreshToken: res.refreshToken,
        };
      } catch (err) {
        return {
          success: false,
          error: err instanceof Error ? err.message : 'Sign up failed',
        };
      }
    },
  };
}
